<template>
  <!-- 空白页面 适用全屏布局-->
  <div class="blank-layout">
    <router-view /> <!-- 全屏页面（如404）直接渲染 -->
  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped>

</style>
